import { Controller } from "@hotwired/stimulus";
import { createTimeline } from "animejs";


export default class extends Controller {
    static targets = ["video", "image"]

    initialize() {
        this.timeline = createTimeline({
            defaults: {
                duration: 500,
                ease: "easeOutQuart"
            }
        });
        this.imageTargets.forEach(element => {
            this.timeline.add(
                element,
                {
                    opacity: 1
                }
            )
        });
        this.timeline.pause();

        this.videoTarget.addEventListener("replay", this.replay.bind(this))
    }

    replayTimeline(e) {
        this.timeline.restart();
    }

    replay(e) {
        this.imageTargets.forEach(element => {
            element.style.opacity = 0;
        });
        this.replayTimeline(e);
    }
}